module.exports = __webpack_public_path__ + "static/roadmap2019-0f5f3789cf87ba937d85916863cb782b.svg";